import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getZonesProjects() {
      return getState().projects;
    },
    isZonesProjectsRetrievalRequestFailure() {
      return getState().request.isFailure;
    },
    isZonesProjectsRetrievalRequestPending() {
      return getState().request.isPending;
    },
    isZonesProjectsRetrievalRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
